<template src="./VehicleTypeAdd.html"></template>

<script>
import { MESSAGES } from "@/utils/constants";
import { notify, notifyApiError } from "@/utils/notification-helper";

export default {
  data: function() {
    return {
      add: this.$route.params.add,
      id: null,
      name: null
    };
  },
  methods: {
    goToListPage: function() {
      this.$router.push({ name: "VehicleType" });
    },
    clearAll: function() {
      this.name = null;
    },
    addVehicleType: function() {
      if (this.name) {
        this.vehicleTypeData = {
          Name: this.name
        };
        if (this.add) {
          this.$store.dispatch("vehicleType/addVehicleType", this.vehicleTypeData).then(() => {
            notify(MESSAGES.CHANGES_SAVE_SUCCESS);
            this.goToListPage();
            this.clearAll();
          })
          .catch(notifyApiError);
        } else {
          this.$store.dispatch("vehicleType/updateVehicleType", this.vehicleTypeData).then(() => {
            notify(MESSAGES.CHANGES_SAVE_SUCCESS);
            this.goToListPage();
            this.clearAll();
          })
          .catch(notifyApiError);
        }
      }
    }
  },
  beforeMount() {
    if (!this.$route.params.add) {
      this.vehicleTypeEditData = this.$store.getters["vehicleType/editVehicleType"];
      this.id = this.vehicleTypeEditData.id;
      this.name = this.vehicleTypeEditData.name;
    }
  }
};
</script>


